/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable jsx-quotes */
/* eslint-disable max-len */
import './PriceHistoryMarker.css';

import React from 'react';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'PriceHistoryMarker');

export function PriceHistoryMarker({
    isUp = false,
    isSmall = false
}: {
    isSmall?: boolean;
    isUp?: boolean;
}) {
    const width = isSmall ? '10' : undefined;
    const height = isSmall ? '10' : undefined;

    return (<span className={cn(null, { small: isSmall })}>
        {isUp ? <PriceHistoryIconUp width={width} height={height} /> : <PriceHistoryIconDown width={width} height={height} />}
    </span>);
}

function PriceHistoryIconUp({
    width = '16',
    height = '16'
}: {
    width?: string;
    height?: string;
}) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12 11L7.99997 4L4 11L12 11Z" fill="#E81F0C"/>
    </svg>);
}

function PriceHistoryIconDown({
    width = '16',
    height = '16'
}: {
    width?: string;
    height?: string;
}) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4 5L8.00003 12L12 5.00002L4 5Z" fill="#78BC29"/>
    </svg>);
}
